// TODO: This should be in an .env file
export const BASE_URL = "https://api.veracity.london";
//export const BASE_URL = 'https://devapi.veracity.london'
//export const BASE_URL = 'http://localhost:8000'
